import { render } from "./AdminView25Liquidation.vue?vue&type=template&id=356f51eb"
import script from "./AdminView25Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminView25Liquidation.vue?vue&type=script&lang=js"

import "./AdminView25Liquidation.vue?vue&type=style&index=0&id=356f51eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__